import React from 'react';

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
    const addMessageToState = (message) => {
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, message]
        }));
    }

    const meggageHandler = () => {
        const message = createChatBotMessage("Hello Vamshi");
        addMessageToState(message);
    }
    
  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            meggageHandler
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;